// CSV-02 MH-5a: 호텔 앱의 작업 호텔 판정 규칙. 화면 코드와 분리해 테스트합니다.

/** 쓸 수 있는(잠기지 않고 승인된) 접근 호텔만, 서버 정렬 순서 그대로 */
export function usableHotels(myHotels) {
  return (myHotels || []).filter(
    (o) =>
      o &&
      o.locked !== true &&
      o.joinStatus === 'APPROVED' &&
      o.isUsable !== false,
  );
}

/** 전환기를 보여 줄지 — 쓸 수 있는 접근 호텔이 2개 이상일 때만(1개면 지금 화면과 같음) */
export function canSwitchHotel(myHotels) {
  return usableHotels(myHotels).length >= 2;
}

/** 화면에 보일 호텔 이름. 이름이 없으면 호텔 번호(#id) */
export function hotelLabel(hotel) {
  return hotel?.hotelName || `#${hotel?.hotelId}`;
}

/** 지금 토큰의 작업 호텔 행(서버가 isActive로 표시). 없으면 null */
export function activeHotelOf(myHotels) {
  return (myHotels || []).find((o) => o?.isActive === true) || null;
}

/**
 * 내 정보(/my)에 작업 호텔을 반영합니다.
 * 호텔 앱의 여러 화면이 myInfo.hotel.hotelId·myInfo.authority를 "지금 호텔·역할"로 쓰므로,
 * 범위를 전환했으면 그 값을 작업 호텔 기준으로 바꾸고 원래 기본 호텔은 defaultHotelId로 남깁니다.
 * 작업 호텔이 기본 호텔과 같거나(다중 호텔 꺼짐 포함) 알 수 없으면 그대로 돌려줍니다.
 */
export function applyActiveHotel(myInfo, myHotels) {
  const active = activeHotelOf(myHotels);
  const defaultHotelId = myInfo?.hotel?.hotelId;
  if (!myInfo || !active || defaultHotelId == null) return myInfo;
  if (
    active.hotelId === defaultHotelId &&
    active.authority === myInfo.authority
  ) {
    return myInfo;
  }
  return {
    ...myInfo,
    authority: active.authority || myInfo.authority,
    hotel: { ...myInfo.hotel, hotelId: active.hotelId, defaultHotelId },
  };
}

/**
 * 알림 마지막 확인 저장 키. 여러 호텔을 오가는 사용자는 호텔별로 따로 저장해 다른 호텔의 확인
 * 시각 때문에 새 알림 표시가 숨지 않게 합니다. 호텔이 1개면 기존 키를 그대로 씁니다.
 */
export function lastCheckNotificationKey(userNo, hotelId, multiHotel) {
  return multiHotel && hotelId != null
    ? `${userNo}-${hotelId}-lastcheck-notification`
    : `${userNo}-lastcheck-notification`;
}
